// extracted by mini-css-extract-plugin
module.exports = {"container":"NfumSummaryItem_container__4VKVu","label":"NfumSummaryItem_label__Gdf8G","value":"NfumSummaryItem_value__ndiQU","horizontal":"NfumSummaryItem_horizontal__bUU5z"};